export const DOMAIN_TITLE = 'PRESTACT';
export const DOMAIN = `https://prestact.wearenotalone.fr/index.php`;
export const API_URL = `${DOMAIN}`;
// export const API_PORT = `5000`;
// export const API_URL = `${DOMAIN}:${API_PORT}`;



// WEBPACK FOOTER //
// ./src/config/env.js